function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#accddc",
      strokeWidth: 1.05263162,
      fillOpacity: 1
    },
    d: "M40 13H30V3Z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.5,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      fillOpacity: 1,
      stroke: "#b8b8b8",
      strokeWidth: 1.5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M40 45H8V3h22l10 10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8b8b8",
      fillOpacity: 1,
      strokeWidth: 1.5,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "M40 13H30V3Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9 42V12h30v30Z",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.1744186,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86 151.844c33.325-19.753 53.75-54.96 53.75-94.197v-20.29L86 17.468 32.25 37.356v20.29c0 39.238 20.425 74.445 53.75 94.198",
    style: {
      fill: "#fff"
    },
    transform: "translate(9 12) scale(.17442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 155.875c-.672 0-1.478-.134-2.016-.537C49.047 134.644 28.22 98.094 28.22 57.647v-20.29c0-1.748 1.075-3.226 2.687-3.763l53.75-19.888a5.039 5.039 0 0 1 2.822 0l53.616 19.888c1.612.537 2.687 2.15 2.687 3.762v20.29c0 40.448-20.828 76.998-55.765 97.692-.538.403-1.344.537-2.016.537zM36.281 40.178v17.469c0 36.819 18.544 70.01 49.719 89.494 31.175-19.35 49.719-52.675 49.719-89.494V40.178L86 21.768Z",
    style: {
      fill: "#841414",
      fillOpacity: 1
    },
    transform: "translate(9 12) scale(.17442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 136.525c-.806 0-1.747-.269-2.419-.806C62.216 119.997 48.644 96.75 45.15 70.547c-.269-2.15 1.21-4.166 3.494-4.569 2.15-.269 4.165 1.21 4.568 3.494C56.303 92.45 67.86 112.875 86 127.253c21.366-16.931 33.594-42.194 33.594-69.74V51.33L86 38.97 49.719 52.406c-2.15.807-4.435-.268-5.24-2.418-.807-2.15.268-4.435 2.418-5.241l37.76-13.84a5.039 5.039 0 0 1 2.821 0l37.625 13.974c1.613.538 2.688 2.15 2.688 3.763v9.003c0 31.175-14.244 59.662-39.238 78.072-.806.537-1.747.806-2.553.806z",
    style: {
      fill: "#e1c7c7",
      fillOpacity: 1
    },
    transform: "translate(9 12) scale(.17442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 34.669v97.825c23.784-17.603 37.625-44.881 37.625-74.847v-9.003z",
    style: {
      fill: "#e1c7c7",
      fillOpacity: 1
    },
    transform: "translate(9 12) scale(.17442)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityPolicy);
export default __webpack_public_path__ + "static/media/securityPolicy.aa80f57849553ad3c0beff86d6f0e58d.svg";
export { ForwardRef as ReactComponent };